const root = process.env.REACT_APP_API_GRAPHQL;
const certificacionesRoute =  root + '?query={certificacion{textoalternativo imagen{urls} imagen2x{urls} imagen3x{urls}}}';

export default certificacionesRoute;